import type { EventName } from "@lit/react";
import { CustomField as CustomFieldElement, type CustomFieldEventMap as _CustomFieldEventMap, } from "@vaadin/custom-field/vaadin-custom-field.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { CustomFieldElement, };
export type CustomFieldEventMap = Readonly<{
    onValidated: EventName<_CustomFieldEventMap["validated"]>;
    onChange: EventName<_CustomFieldEventMap["change"]>;
    onInvalidChanged: EventName<_CustomFieldEventMap["invalid-changed"]>;
    onValueChanged: EventName<_CustomFieldEventMap["value-changed"]>;
}>;
const events = { onValidated: "validated", onChange: "change", onInvalidChanged: "invalid-changed", onValueChanged: "value-changed" } as CustomFieldEventMap;
export type CustomFieldProps = WebComponentProps<CustomFieldElement, CustomFieldEventMap>;
export const CustomField = createComponent({
    elementClass: CustomFieldElement, events, react: React, tagName: "vaadin-custom-field"
});
